function startTimer(cooldown, timerDone){
  timerDone.value = false;
  setTimeout(() => {
    timerDone.value = true;
  }, cooldown);
  return timerDone.value
}

var timerDone = { value: true };

export {startTimer, timerDone};